import { Form } from "react-bootstrap";
import { InputPicker } from "rsuite";
import { useEffect, useState } from "react";

export default function InputSearch({
  value,
  label,
  name,
  error,
  touched,
  onChangeMethod,
  onBlurMethod,
  values,
  required,
  labelVal,
  valueVal,
  disabled,
  readOnly,
  createLink,
  createText,
  changeValuesToStrings,
  creatable,
  onCreate,
  renderMenu,
  zIndex
}: {
  value: string | number;
  label: string;
  name: string;
  error?: string;
  touched?: boolean;
  onChangeMethod: any;
  onBlurMethod?: any;
  values: Array<any>;
  required?: boolean;
  labelVal?: string;
  valueVal?: string;
  disabled?: boolean;
  readOnly?: boolean;
  createLink?: string;
  createText?: string;
  changeValuesToStrings?: boolean;
  creatable?: boolean;
  onCreate?: any;
  renderMenu?: any;
  zIndex?: number;
}) {
  const [processValue, setProcessValue]: Array<any> = useState([]);

  useEffect(() => {
    setProcessValue(transformArray());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  const transformArray = () => {
    return values.map((el) =>
      changeValuesToStrings
        ? {
            value: el[valueVal || "value"].toString(),
            label: el[labelVal || "label"].toString(),
          }
        : {
            value: el[valueVal || "value"],
            label: el[labelVal || "label"],
          }
    );
  };

  return (
    <div className="mb-3">
      <Form.Label className="d-flex justify-content-between">
          <p className="m-0">{label} {required && <span className="text-danger">*</span>}</p>
          <a href={createLink}>{createText}</a>
      </Form.Label>
      <InputPicker
        data={processValue}
        size="md"
        style={{ width: "100%", padding: 0, zIndex: zIndex }}
        value={value}
        id={name}
        name={name}
        onChange={(value) => onChangeMethod({ target: { value, name } })}
        onBlur={onBlurMethod}
        className={
          "form-control" +
          (error !== undefined && touched !== undefined ? " is-invalid" : "")
        }
        appearance="subtle"
        placeholder="Seleccionar"
        disabled={disabled}
        readOnly={readOnly}
        creatable={creatable}
        onCreate={onCreate}
        renderMenu={renderMenu}
      />
      <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
    </div>
  );
}


        